import { useState, useCallback } from "react";
import { ResumeDataService } from "@/app/services/create-resume/resume-data.js";
import { toast } from "sonner";

export const useCompanyClaim = () => {
  const [isLoading, setIsLoading] = useState(false);
  const claimService = new ResumeDataService();

  const requestClaimOTP = useCallback(async (payload) => {
    setIsLoading(true);
    try {
      await new Promise((resolve, reject) => {
        claimService.requestCompanyClaimOTP(
          payload,
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });

			// Simulate API call
			// await new Promise((resolve) => setTimeout(resolve, 1500));

			return true;
    } catch (error) {
			toast.error(`Error in processing otp request: ${error.response.data.message ?? error.response.data.error}`);
			return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const verifyClaimOTP = useCallback(async (payload) => {
    setIsLoading(true);
    try {
      const response = await new Promise((resolve, reject) => {
        claimService.verifyCompanyClaimOTP(
          payload,
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });

			// Simulate API call
			// await new Promise((resolve) => setTimeout(resolve, 1500));

			return response?.data || null;
    } catch (error) {
			toast.error(`Error in verifying the otp: ${error.response.data.message ?? error.response.data.error}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    requestClaimOTP,
    verifyClaimOTP,
    isLoading
  };
};
